import * as Sentry from '@sentry/react'
import { User } from '../src/interfaces/user'
import { API_BASE_URL, X_API_KEY } from './api'

export class UserService {
  async getAllUsers(): Promise<User[]> {
    try {
      const response = await fetch(`${API_BASE_URL}/all/full`, {
        headers: {
          'x-api-key': X_API_KEY,
        },
      })
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      const result = await response.json()
      return result.users as User[]
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          action: 'getAllUsers',
          timestamp: new Date().toISOString(),
        },
        tags: {
          type: 'api_error',
          method: 'getAllUsers',
        },
      })
      throw error
    }
  }

  filterEstablishmentUsers(users: User[]): User[] {
    return users.filter(user => user.status.includes('mon statut ici'))
  }
}

export const checkEmailExists = async (
  email: string,
  userId: any,
): Promise<boolean> => {
  try {
    const response = await fetch(`${API_BASE_URL}/all/full`, {
      headers: {
        'x-api-key': X_API_KEY,
      },
    })
    const data = await response.json()

    if (!response.ok) {
      throw new Error('Failed to fetch users')
    }

    const userExists = data.users.some(
      (user: { email: string }) => user.email === email,
    )
    return userExists
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        action: 'checkEmailExists',
        email,
        userId,
        timestamp: new Date().toISOString(),
      },
      tags: {
        type: 'api_error',
        method: 'checkEmailExists',
      },
    })
    return false
  }
}
